import { IconSVG } from '../types';

export const Alert = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        d="M2.725 21.5a.973.973 0 0 1-.85-.5 1.1 1.1 0 0 1-.138-.488.9.9 0 0 1 .138-.512l9.25-16q.15-.25.387-.375T12 3.5t.487.125a1 1 0 0 1 .388.375l9.25 16q.15.25.137.512a1.1 1.1 0 0 1-.137.488.97.97 0 0 1-.85.5zm9.275-3q.424 0 .712-.288A.97.97 0 0 0 13 17.5a.97.97 0 0 0-.288-.712A.97.97 0 0 0 12 16.5a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712q0 .424.287.712.288.288.713.288m0-3q.424 0 .712-.287A.97.97 0 0 0 13 14.5v-3a.97.97 0 0 0-.288-.713A.97.97 0 0 0 12 10.5a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713v3q0 .424.287.713.288.287.713.287"
      />
    </svg>
  );
};
